<template>
    <Breadcrumbs main="Apps" title="Tasks" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <taskSidebar />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const taskSidebar = defineAsyncComponent(() => import("@/components/theme/task/taskSidebar.vue"))
</script>